import { useLocalization } from "@fluent/react";
import BalancesPlusDropdown from "../BalancesPlusDropdown";
import styles from "./EmptyAccountBalances.module.scss";

export const EmptyAccountBalances = () => {
  const { l10n } = useLocalization();

  return (
    <div className={styles["empty-account-balances"]}>
      <div>
        <div className="fontWeight--bold">
          {l10n.getString("account-balances-empty-state-title")}
        </div>
        <div className="padding--top--xxs">
          {l10n.getString("account-balances-empty-state-description")}
        </div>
      </div>
      <BalancesPlusDropdown />
    </div>
  );
};

export default EmptyAccountBalances;
